<template>
    <div>
    <Nav :isDark.sync="isDark" @darkmode="isDark = $event"></Nav>
    <div class="">
        <div v-if="fullscreenLoading" class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 76px);">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <!--初始加载-->
        <div class="text-center" style="height: calc(100vh - 76px);" v-if="this.matchData.length === 0 && !fullscreenLoading">
            <div class="nodata d-flex flex-column justify-content-center" :class="{'h-100':this.matchData.length === 0}">
                <span class="align-center text-secondary">暂无数据</span>
            </div>
        </div>
        <!--无数据状态-->
        <div class="sword" v-if="this.matchData.length !== 0">
            <div class="d-flex justify-content-between align-items-center border-bottom py-1 bg-light px-2">
                <!-- <h4 class="fs-12 mb-0 me-4">{{ dateTitle }}</h4> -->
                <el-date-picker v-model="dateTitle" type="date" placeholder="选择日期" format="MM-dd" value-format="yyyy-MM-dd" size="mini" :editable="false" @change="changeDate"></el-date-picker>
                <router-link :to="'/checkback'" class="text-primary fs-12" style="cursor: pointer;">电脑端查看>></router-link>
            </div>
            <div v-for="(item,index) in matchData" :key="index">
                <div>
                    <div class="d-flex justify-content-between align-items-center p-2 border-bottom">
                        <!--竖-->
                        <div class="d-flex flex-column">
                            <div>
                                <span class="fs-10 me-3" :style="{ color: item.color }">{{ item.league }}</span>
                                <span class="fs-10 time me-2">{{ formattedDateToMMDD(item.date,item.time) }}</span>
                                <span class="fs-10 time">{{ item.time }}</span>
                            </div>
                            <div class="d-flex flex-column">
                                <span>
                                    <b class="fs-14">{{ item.home }}</b>
                                    <font class="fs-12 ms-1">{{ filteredNum(item.home_rank) }}</font>
                                </span>
                                <span>
                                    <b class="fs-14">{{ item.away }}</b>
                                    <font class="fs-12 ms-1">{{ filteredNum(item.away_rank) }}</font>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex flex-column pe-1">
                            <div class="d-flex">
                                <div class="d-flex flex-column align-items-end justify-content-center">
                                    <div>
                                        <span class="fs-12 text-secondary">{{ "共 "+history[index][0].count+" 场" }}</span>
                                    </div>
                                    <div class="d-flex flex-column align-items-end">
                                        <span class="fs-12 mt-1 text-primary"><a class="text-decoration-none" :href="'https://m.titan007.com/Analy/ShiJian/'+item.id+'.htm'" target="_blank">{{ null == item.handicap || undefined == item.handicap ? '' : item.handicap }}</a></span>
                                        <span class="fs-12 mt-1 text-primary">{{ null == item.bigsmall || undefined == item.bigsmall ? '' : item.bigsmall }}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-items-end ms-3">
                                    <div>
                                    <span class="fs-12 text-secondary">{{ "胜" + history[index][0].wdl[0] + "%" }}</span></div>
                                    <div class="d-flex flex-column">
                                        <span class="fs-12 text-secondary pt-1">{{ "平" + history[index][0].wdl[1] + "%" }}</span>
                                        <span class="fs-12 text-secondary pt-1">{{ "负" + history[index][0].wdl[2] + "%" }}</span>
                                    </div>
                                </div>
                                <a v-if="history[index].length > 0" class="text-decoration-none d-flex flex-column justify-content-center align-items-end text-end" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index" aria-expanded="false" aria-controls="collapseExample">
                                    <b class="fs-18 ps-3 qsdaColor" :style="{color: qsdaColorSet(item.handicap,item.qsda)}" style="width: 50px;">{{ item.qsda }}</b>
                                </a>
                            </div>
                        </div>
                        <!--横-->
                        <!-- <div class="team d-flex align-items-center">
                            <div class="flex-fill text-end d-flex flex-column">
                                <span class="fs-10" :style="'color:'+ item.color">{{ item.league }}</span>
                                <span>
                                <font class="fs-12 me-1">{{ filteredNum(item.home_rank) }}</font>
                                <b class="fs-14">{{ item.home }}</b>
                                </span>
                                <span class="fs-10" style="color:#db7900;">
                                    <a class="text-decoration-none" :href="'https://m.titan007.com/Analy/ShiJian/'+item.id+'.htm'" target="_blank">
                                    {{ item.handicap }}</a>
                                </span>
                            </div>
                        </div>
                        <div class=" d-flex flex-column align-items-center">
                            <span class="fs-10 text-secondary">{{ "共 "+history[index][0].count+" 场" }}</span>
                            <a v-if="history[index].length>0" class="text-decoration-none" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index" aria-expanded="false" aria-controls="collapseExample">
                                <b class="fs-18 px-3 qsdaColor" :style="{color: qsdaColorSet(item.handicap,item.qsda)}">{{ item.qsda }}</b>
                            </a>
                            <span class="fs-10 text-secondary">{{ "胜" + history[index][0].wdl[0] + "%" }}，{{ "平" + history[index][0].wdl[1] + "%" }}，{{ "负" + history[index][0].wdl[2] + "%" }}</span>
                        </div>
                        <div class="team d-flex align-items-center">
                            <div class="flex-fill d-flex flex-column">
                                <span class="fs-10 time">{{ item.time }}</span>
                                <span>
                                <b class="fs-14">{{ item.away }}</b>
                                <font class="fs-12 ms-1">{{ filteredNum(item.away_rank) }}</font>
                                </span>
                                <span class="fs-10" style="color:#db7900;">{{ item.bigsmall }}</span>
                            </div>
                            <div style="width: 26px;height: 26px;"></div>
                        </div> -->
                    </div>
                </div>
                <div class="collapse" :id="'collapse'+index">
                    <div v-for="(cell,index) in history[index][0].res" :key="index">
                        <div class="d-flex justify-content-between align-items-center py-2 border-bottom px-1" :style="'background:'+stateBg(cell.state)">
                            <div class="team d-flex align-items-center">
                                <div class="flex-fill text-end d-flex flex-column">
                                    <div class="fs-10 d-flex justify-content-end grey">
                                        <span class="fs-10 grey me-2">{{ cell.league }}</span>
                                        <span class="me-1">{{ cell.h_index1 }}</span>
                                        <span class="me-1" style="color:#db7900;">{{ cell.init }}</span>
                                        <span class="">{{ cell.a_index1 }}</span>
                                    </div>
                                    <b class="fs-14">{{ cell.home }}</b>
                                    <div class="fs-10 d-flex justify-content-end grey">
                                        <span class="me-1">{{ cell.h_index2 }}</span>
                                        <span class="me-1" style="color:#db7900;">{{ cell.final }}</span>
                                        <span class="">{{ cell.a_index2 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center">
                                <span class="fs-10 grey">{{ cell.qsda }}</span>
                                <b class="fs-14" :style="'color:' + checkColor(cell.state)">{{ cell.state }}</b>
                                <span class="fs-10 grey">{{ cell.score }}</span>
                            </div>
                            <div class="team d-flex align-items-center">
                                <div class="flex-fill d-flex flex-column">
                                    <div class="fs-10 d-flex justify-content-start grey">
                                        <span class="fs-10 time me-2">{{ shortDate(cell.date) }}</span>
                                        <span class="me-1">{{ cell.big_1 }}</span>
                                        <span class="me-1" style="color:#db7900;">{{ cell.bs_init }}</span>
                                        <span>{{ cell.samll_1 }}</span>
                                    </div>
                                    <b class="fs-14">{{ cell.away }}</b>
                                    <div class="fs-10 grey">
                                        <span class="me-1">{{ cell.big_2 }}</span>
                                        <span class="me-1" style="color:#db7900;">{{ cell.bs_final }}</span>
                                        <span class="me-1">{{ cell.samll_2 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loadMore && !fullscreenLoading" class="text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div v-if="this.checkbackData.length !== 0">
                <button type="button" :class="{'btn-dark': isDark}" class="btn btn-light text-secondary w-100 fs-12" v-if="!noMore" @click="this.loadData">加载更多</button>
                <div v-if="noMore && !fullscreenLoading" class="text-center" style="color: #ccc;">-- 已经到底了 --</div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>
<script>
// import checkbackData from '../data/checkback.json'
import Footer from './comment/footer.vue'
import colorList from '../data/colorList.json'
import { checkColor, handicapToNum, convertToReal, compare, dateFormatted,filteredNum, formattedDateToMMDD } from '../utils/utils'
import Nav from './comment/nav.vue'
import { throttle } from 'lodash';
import { checkbackListUrl, checkbackResUrl } from '../constants/http.config'
export default {
    components: { Nav,Footer },
    data() {
        return {
            dateTitle: '',
            fullscreenLoading: true,
            visibleData: [],
            matchData: [],
            history: [],
            leagueColor: '#000',
            qsdaColor: 'rgb(128,0,255)',
            resStr: '',
            lowOrHight: 2,
            isDark: false,
            currentPage: 1,
            pageSize: 10,
            loadMore: false,
            hasHistory: false,
            noMore : false,
            showAll: [],
            checkbackData: [],
            columns: [
                { label: '日期', prop: 'date'},
                { label: '联赛', prop: 'league'},
                { label: '主队', prop: 'home'},
                { label: '比分', prop: 'score'},
                { label: '客队', prop: 'away'},
                {label: '结果', prop: 'state'},
                { label: 'qsda', prop: 'qsda'},
                { label: '指数1', prop: 'index1'},
                {label: 'Crown', prop: 'init'},
                {label: '指数2', prop: 'index2'},
                {label: '大球', prop: 'big'},
                {label: '大小球', prop: 'bigsmall'},
                {label: '小球', prop: 'small'},
            ],
            result: [
                {text: '胜',value: '胜'},
                {text: '平',value: '平'},
                {text: '负',value: '负'}
            ]
        }
    },
    mounted() {
        // this.matchData = checkbackData
        // this.getdata().then(()=>{
        //     this.loadData();
        // });
        this.initData();
        // 使用lodash的throttle函数创建一个新的函数，这个新函数会在每300ms内最多执行一次handleScroll函数
        this.throttledHandleScroll = throttle(this.handleScroll, 300);
        // 监听滚动事件
        // window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        // 移除滚动事件监听
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        dateFormatted,
        filteredNum,
        checkColor,
        formattedDateToMMDD,
        async initData(){
            const date = dateFormatted(new Date());
            this.dateTitle = date;
            const url = 'https://api.qsda.net/api/match/date/' + date;
            await this.getGsData(url);
        },
        //加载广实数据
        async getGsData(url){
            fetch(url)
            .then(response => response.json())
            .then(data => {
                this.allMatch = data.data;
                this.loading = false;
                // console.log(this.allMatch.length,this.matchData.length);
                // 设置目标时间为 10:30 AM
                let targetTime = new Date();
                let currentTime = new Date();
                targetTime.setHours(10);
                targetTime.setMinutes(35);
                targetTime.setSeconds(0);
                // console.log(this.dateTitle,this.dateFormatted(currentTime));
                if (this.dateTitle === this.dateFormatted(currentTime)) {
                    // console.log("今日数据");
                //    currentTime.setDate(currentTime.getDate() - 1)
                    // 比较当前时间和目标时间
                    if (currentTime > targetTime) {
                        console.log("当前时间大于 10:35 AM，读取今日数据");
                        // date = this.dateFormatted(currentTime);
                    } else {
                        console.log("当前时间小于 10:35 AM，读取昨天数据");
                        // 将日期减一天
                        currentTime.setDate(currentTime.getDate() - 1)
                        this.dateTitle = this.dateFormatted(currentTime);
                        // console.log(this.dateFormatted(currentTime)); 
                    }
                }
                if (data.data.length > 0) {
                    if (null !== data.data[0].league || data.data[0].league !== '') {
                        // console.log('nnnnnn');
                        this.isnew = true;
                    }
                    //过滤出北单数据
                    for (let index = 0; index < this.allMatch.length; index++) {
                        const elm = this.allMatch[index];
                        // for (let i = 0; i < this.beidan.length; i++) {
                        //     const lgName = this.beidan[i];
                        //     if (elm.league === lgName) {
                                this.checkbackData.push(elm);
                        //     }
                        // }
                    }
                    // console.log('aaaa',this.checkbackData);
                    this.loadData();
                }
            })
            .catch(error => console.error('Error:', error));
        },
        async getHistory(qsda,init,bsInit){
            // console.log(qsda,init,bsInit);
            let res = []
            let countW = 0;
            let countD = 0;
            let countL = 0;
            const url = checkbackResUrl + 'qsda=' + qsda + '&init=' + init + '&bsInit=' + bsInit + '&pageNum=1&pageSize=50';
            // const url = 'localhost:8888/api/match/history?';
            await fetch(url, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(response => response.json())
            .then(data => {
                    res = data.data.list;
                    for (let index = 0; index < data.data.list.length; index++) {
                        const element = data.data.list[index];
                        if (element.state === '胜') {
                            countW = countW+1;
                        }
                        if (element.state === '平') {
                            countD = countD+1;
                        }
                        if (element.state === '负') {
                            countL = countL+1;
                        }
                    }
                    let countNum = countW + countD + countL;
                    let wP = countNum > 0 ? Math.round((countW/countNum)*100) : 0;
                    let lP = countNum > 0 ? Math.round((countL/countNum)*100) : 0;
                    let dP = countNum > 0 ? 100-(wP+lP) : 0;
                    let resStr = countNum > 0 ? `${countNum}场，${wP}%胜，${dP}%平，${lP}%负` : ''
                    console.log(countW,countD,countL,countNum,wP,dP,lP);
                    res = [{
                        count: countNum,
                        wdl: [wP,dP,lP],
                        res: data.data.list
                    }]
            });
            console.log(res);
            return res;
        },
        //旧
        async getdata(){
            // const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            // console.log(this.checkbackData[0].date,this.dateFormatted(today),this.dateFormatted(tomorrow));
            // const url = 'https://api.qsda.net/api/match/checkback';
            await fetch(checkbackListUrl, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(response => response.json())
            .then(async res => {
                console.log('checkback length',res.data.length);
                this.checkbackData = res.data;
                this.dateTitle = res.data[0].date;
            }).catch((error)=>{
                console.log(error);
            });
            
        },
        handleScroll() {
            let scrollTop = document.documentElement.scrollTop; //滚动条在Y轴滚动过的高度
            let scrollHeight = document.documentElement.scrollHeight; //滚动条的高度
            let clientHeight = document.documentElement.clientHeight; //浏览器的可视高度
            // 检查是否接近页面底部
            if (scrollTop + clientHeight == scrollHeight && !this.loadMore) {
                // 加载更多数据
                this.loadData();
                console.log('加载更多');
            }
        },
        async dataHandler(num, lengthNum){
            // const today = new Date();
            // const currentHours = today.getHours()
            // const currentMin = today.getMinutes();            
            // if (currentHours < 10 || currentHours == 10 && currentMin < 30 || this.checkbackData[0].date == this.dateFormatted(today)) {
                // console.log('数据是今天或明日');
                for (let index = num; index < lengthNum; index++) {
                    const element = this.checkbackData[index];
                    const noVal = element.handicap == null || element.handicap == '';
                    // console.log(index+1,noVal);
                    if (!noVal) {
                        // console.log('has hdVal',element.handicap);
                        const handicapNum = handicapToNum(element.handicap);
                        const realHandicapNum = convertToReal(element.qsda);
                        if (handicapNum !== 0) {
                            if (typeof handicapNum !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                                    this.lowOrHight = compare(handicapNum, realHandicapNum);
                                if(this.lowOrHight === 0){
                                    this.qsdaColor = 'black';
                                }
                                if (this.lowOrHight === 1) {
                                    this.qsdaColor = 'red';
                                }
                                if (this.lowOrHight === -1) {
                                    this.qsdaColor = 'green';
                                }
                            }
                        }
                        if ( element.color == '#000' || typeof element.color == 'undefined') {
                            for (let i = 0; i < colorList.length; i++) {
                                // console.log(colordata[i].name.indexOf(league));
                                    if (element.league.indexOf(colorList[i].league)!==-1) {
                                        element.color = colorList[i].color;
                                    break;
                                }
                            }
                        }else{
                            // element.color = '#000';
                        }
                        if (element.qsda !== '' && element.bigsmall !== '') {
                            const transformHandicap = element.handicap.replace('受', '*');
                            await this.getHistory(element.qsda,transformHandicap,element.bigsmall).then((data)=>{
                                if (data.length > 0) {
                                    // console.log('有回查');
                                    this.fullscreenLoading = false;
                                    this.hasHistory = true
                                    this.matchData.push(element);
                                    this.history.push(data);
                                    this.showAll.push(false);
                                // console.log('222',res);
                                }
                            })
                        }
                    }
                }
            console.log(this.matchData,this.showAll);
            // }else{
            //     console.log('数据不是今日或明日的');
            //     this.checkbackData = [];
            //     this.fullscreenLoading = false;
            // }
        },
        async loadData() {
            console.log('loadmore');
            // 避免重复加载
            if (this.loadMore) {
                return;
            }
            this.loadMore = true;
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize <= this.checkbackData.length ? start + this.pageSize : this.checkbackData.length;
            console.log(start,end,this.currentPage);
            
            
            await this.dataHandler(start,end).then(()=>{
                    this.currentPage++;
                    this.loadMore = false;
                if (start == 0 && this.matchData.length <= 2) {
                    console.log('no his');
                    const start = (this.currentPage - 1) * this.pageSize;
                    const end = start + this.pageSize;
                    console.log(start,end,this.currentPage);
                    this.dataHandler(start,end)
                    this.currentPage++
                }
                if(start !== 0 && this.hasHistory){
                    console.log('has his');
                    this.hasHistory = true;
                    if (this.currentPage > 1 && end == this.checkbackData.length) {
                        this.loadMore = false;
                        this.noMore = true;
                        console.log('没有更多了');
                        return;
                    }
                }
            });
            
        },
        qsdaColorSet(handicap,qsda){
            let qsdaColor = 'rgb(128,0,255)';
            let lowOrHight = 2;
            if (handicap!=='') {
                const handicapNum = handicapToNum(handicap);
                const realHandicapNum = convertToReal(qsda);
                if (handicapNum === 0) {
                    qsdaColor = 'rgb(128,0,255)';
                    return qsdaColor
                }else{
                    if (typeof handicapNum !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                            lowOrHight = compare(handicapNum, realHandicapNum);
                        if(lowOrHight === 0){
                            qsdaColor = this.isDark ? '#ccc' : 'black';
                            return qsdaColor
                        }
                        if (lowOrHight === 1) {
                            qsdaColor = 'red';
                            return qsdaColor
                        }
                        if (lowOrHight === -1) {
                            qsdaColor = 'green';
                            return qsdaColor
                        }
                    }
                }
            }
        },
        stateBg(key){
            let color = '';
            switch (key) {
                case '胜':
                    color = 'rgba(255, 0, 0, 0.1)';
                    break;
                case '平':
                    color = 'rgba(0, 128, 0, 0.1)';
                    break;
                case '负':
                    color = 'rgba(0, 0, 255, 0.1)';
                    break;
                default:
                    break;
            }
            return color;
        },
        shortDate(date){
            return (date.replace(/年|月/g, '/').replace(/日/g, '')).substring(2);
        },
        changeDate(){
            const date = this.dateTitle;
            // console.log(this.dateTitle);
            this.matchData = [];
            this.allMatch = [];
            this.checkbackData = [];
            this.history = [];
            this.currentPage = 1;
            this.loadMore = false;
            this.noMore = false;
            if (this.dateTitle !== null) {
                const url = 'https://api.qsda.net/api/match/date/' + date;
                this.getGsData(url);
            }
        }
    }
}
</script>
<style lang="scss">
    @import '../assets/sass/global.scss';
    .team { width: 45%;}
    font,.grey {color: rgb(136, 136, 136);}
    .bgdark {background-color: #0d1421}
    .sword {padding-top: 60px;}
    .sword-items {
        .btn {
            border-radius: 0;
        }
    }
    @media (max-width: 1024px) {
        .match-team {
            display: flex;
            flex-direction: column;
        }
    }
</style>